export const getPricingOfAccountEmailCampaign = {
  GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST: "GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST",
  GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_SUCCESS: "GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_SUCCESS",
  GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_ERROR: "GET_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_ERROR",
};

export const editPricingOfAccountEmailCampaign = {
  EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST: "EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_REQUEST",
  EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_SUCCESS: "EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_SUCCESS",
  EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_ERROR: "EDIT_PRICING_OF_ACCOUNT_EMAIL_CAMPAIGN_ERROR",
};
